// extracted by mini-css-extract-plugin
export default {"container":"cn-input_container__RrS8e","label":"cn-input_label__l2zug","input":"cn-input_input__VP0C2"};